__turbopack_context__.v({
  "callout": "CymaticCloud-module__bFuxEG__callout",
  "calloutLabel": "CymaticCloud-module__bFuxEG__calloutLabel",
  "callouts": "CymaticCloud-module__bFuxEG__callouts",
  "calloutsInner": "CymaticCloud-module__bFuxEG__calloutsInner",
  "canvas": "CymaticCloud-module__bFuxEG__canvas",
  "cymatic": "CymaticCloud-module__bFuxEG__cymatic",
  "fail": "CymaticCloud-module__bFuxEG__fail",
  "hoverBadge": "CymaticCloud-module__bFuxEG__hoverBadge",
  "pass": "CymaticCloud-module__bFuxEG__pass",
  "visible": "CymaticCloud-module__bFuxEG__visible",
});
